module.exports = __webpack_public_path__ + "static/media/sass.2a497c76.svg";